import React from "react";
import { MarketValueProps } from "./utils/types";
import { ValueTable } from "./utils/ValueTable";
import { getMarketValueRows, marketValueHeaders } from "./utils/tableConfig";

export const MarketValue: React.FC<MarketValueProps> = ({ data }) => {
    const marketValueData =
        data.appealDetails.appealApproachCalculationData.exportAppealsPackage.marketValueIndication;

    return (
        <ValueTable
            title="Market Value Indication"
            headers={marketValueHeaders}
            rows={getMarketValueRows(marketValueData)}
            data={marketValueData}
        />
    );
};
